<template>
<div class="css-info">
  <div class="css-info-uneditable">
      <div class="css-info-main">
        <a-row>
          <a-col :span="5">
            <span>社員ID</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col :span="5">
            <span>{{employee.eid}}</span>
          </a-col>
          <!-- <a-col :span="2">
            <span>名前</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col :span="10">
            <a-button size="small" disabled>{{employee.name}}</a-button>
          </a-col> -->
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>名前</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
             <a-button size="small" disabled>{{employee.name}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>アカウント</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>{{employee.user.account}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>メール</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>{{employee.user.email}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>入社日付</span>
          </a-col>
          <a-col :span="1">
            <span>：</span>
          </a-col>
          <a-col>
            <span>{{employee.joined_at}}</span>
          </a-col>
        </a-row>
      </div>
      <a-divider/>
      <div class="css-info-sub">
        <a-row v-if="employee.user.userinfo.sex">
          <a-col :span="5">
            <span>性別</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-radio-group :defaultValue="employee.user.userinfo.sex" :options="sex_options" disabled style="float:left" />
          </a-col>
        </a-row>
        <a-row v-if="employee.user.userinfo.birthday">
          <a-col :span="5">
            <span>誕生日</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled icon="calendar">{{employee.user.userinfo.birthday}}</a-button>
          </a-col>
        </a-row>
        <a-row v-if="employee.user.userinfo.postal_code || employee.user.userinfo.address">
          <a-col :span="5">
            <span>住所</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>
              〒{{employee.user.userinfo.postal_code}}
              <br> {{employee.user.userinfo.address}}
            </a-button>
          </a-col>
        </a-row>
        <a-row v-if="employee.user.userinfo.telphone">
          <a-col :span="5">
            <span>携帯</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>{{employee.user.userinfo.telphone}}</a-button>
          </a-col>
        </a-row>
      </div>
      <a-card type="inner" style="margin-top:10px" v-if="employee.employeeinfo.emergency_contact_name||employee.employeeinfo.emergency_contact_telphone">
        <div slot="title" style="padding:0px;margin:0px;text-align:left;">
          <a-tag color="red">緊急連絡先</a-tag>
          <a-tag style="margin-left:10px" color="green" v-if="employee.employeeinfo.emergency_contact_relation">{{employee.employeeinfo.emergency_contact_relation}}</a-tag>
        </div>
        <a-row>
          <a-col :span="5">
            <span>名前</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>{{employee.employeeinfo.emergency_contact_name}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="5">
            <span>携帯</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled>{{employee.employeeinfo.emergency_contact_telphone}}</a-button>
          </a-col>
        </a-row>
      </a-card>
      <a-card type="inner" 　style="margin-top:10px" >
        <div slot="title" style="padding:0px;margin:0px;text-align:left;">
          <a-tag color="red">ビザ情報</a-tag>
        </div>
        <a-row>
          <a-col :span="6">
            <span>在留期限</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled icon="calendar">{{employee.employeeinfo.residence_card_expired}}</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="6">
            <span>パスポート</span>
          </a-col>
          <a-col>
            <span>：</span>
          </a-col>
          <a-col>
            <a-button size="small" disabled icon="calendar">{{employee.employeeinfo.passport_expired}}</a-button>
          </a-col>
        </a-row>
      </a-card>
       <a-card  type="inner" style="margin-top:10px" v-if="employee.permissions.length>0">
        <div slot="title" style="padding:0px;margin:0px;text-align:left;">
          <a-tag color="red">権限</a-tag>
        </div>
        <a-tag v-for="permission in employee.permissions" :key="permission.name">{{permission.name}}</a-tag>
      </a-card>
  </div>
</div>
</template>

<script>
const sex_options = [{
    label: "女",
    value: "female"
  },
  {
    label: "男",
    value: "male"
  },
  {
    label: "未設定",
    value: "unknown"
  }
];
export default {
  name: "infocard",
  props: ["employee"],
  data() {
    return {
      sex_options,
      loading: false
    };
  },
  methods: {
    handleClick() {
      this.loading = !this.loading;
    }
  },
  created() {
    this.isLoading = true;
    this.$logger.d("InfoCard","created",{
      employee:this.employee
    });
    if (!this.employee) {
      this.$notification.error({
        message: "エラー"
      })
    } else {
      if(this.employee.user.userinfo.lastname) this.employee.name =this.employee.user.userinfo.lastname
      if(this.employee.user.userinfo.firstname) this.employee.name=(this.employee.name?this.employee.name + " " + this.employee.user.userinfo.firstname:this.employee.user.userinfo.firstname)
      this.isLoading = false;
    }
  },
  methods: {
    onEditClicked() {
      this.$router.push({
        name: "edit",
        params: {
          info: this.employee,
          canEditName: false
        }
      });
    }
  }
};
</script>
<style scoped>
.css-info {
  padding: 5px 0px 0px 0px;
}

.css-info span {
  float: left;
}

.css-info-uneditable .ant-row {
  margin-top: 10px;
}

.css-info-uneditable button {
  float: left;
  max-width: 100%;
  height: 100%;
  font-size: 12px;
  text-align: left;
}
</style>
